export const BIO_CHARACTER_LIMIT = 50;
export const ONBOARDING_FIELDS = ["headline", "city", "primaryRole", "yearsExperience"] as const;
export type OnboardingField = typeof ONBOARDING_FIELDS[number];
export type FieldErrors = Partial<Record<OnboardingField, string>>;
export const COMPLETENESS_LABELS: Record<string, string> = {
  headline: "Bio", city: "Location", primaryRole: "Primary role", yearsExperience: "Years of experience",
};
export type EducationLevel = "primary" | "high_school" | "college" | "vocational" | "postgraduate";
export type EducationDraft = { level: EducationLevel; school: string; degree: string; yearGraduated: string };
export type ExperienceDraft = { role: string; yearsExperience: string };
export const EDUCATION_LEVELS: { value: EducationLevel; label: string }[] = [
  { value: "primary", label: "Primary school" },
  { value: "high_school", label: "High school" },
  { value: "college", label: "College" },
  { value: "vocational", label: "Vocational / technical" },
  { value: "postgraduate", label: "Postgraduate" },
];
export const blankEducation = (): EducationDraft => ({ level: "college", school: "", degree: "", yearGraduated: "" });
export const blankExperience = (): ExperienceDraft => ({ role: "", yearsExperience: "" });

export function educationDrafts(profile: { educationEntries?: { level?: EducationLevel; school?: string | null; degree?: string | null; yearGraduated?: number | null }[]; education?: string | null }): EducationDraft[] {
  if (Array.isArray(profile.educationEntries) && profile.educationEntries.length > 0) {
    return profile.educationEntries.map((entry) => ({
      level: entry.level || "college",
      school: entry.school || "",
      degree: entry.degree || "",
      yearGraduated: entry.yearGraduated == null ? "" : String(entry.yearGraduated),
    }));
  }
  return profile.education?.trim() ? [{ ...blankEducation(), degree: profile.education.trim() }] : [blankEducation()];
}

export function experienceDrafts(profile: { experienceEntries?: { role?: string | null; yearsExperience?: number | null }[] }): ExperienceDraft[] {
  if (!Array.isArray(profile.experienceEntries)) return [];
  return profile.experienceEntries.map((entry) => ({
    role: entry.role || "",
    yearsExperience: entry.yearsExperience == null ? "" : String(entry.yearsExperience),
  }));
}
